<template>
  <div id="app">
    <!-- navbar -->
    <Navigation v-if="!dashboard"/>
    <router-view class="content" :class="{dashboard: dashboard}" />
    <Press v-if="!dashboard" />
    <Footer />
  </div>
</template>

 
<script>
import Navigation from "@/components/Navigation";
import Press from "@/components/Press";
import Footer from "@/components/Footer";

export default {
  name: "App",
  components: {
    Navigation,
    Press,
    Footer,
  },
  methods: {
    resize () {
      this.$store.commit('updateDimensions');
    }
  },
  mounted () {
    window.addEventListener('resize', this.resize);
    this.resize();
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;0,800;1,400;1,700;1,800&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.2/css/solid.min.css');


:root {
  --black-primary: #293234;
  --blue-primary: #A5D1DB;
  --red-primary: #CD5364;
  --red-dark: #A64351;
  --blue-dark: #73B1BF;
  --blue-light: #F2F8FA;
  --white-primary: #fff;
  --gray-primary: #94999a;
  --gray-light: #e0e5e6;
  --gray-extra-light: #f4f7f8;


  --col-spd: #bc423a;
  --col-cdu: #293234;
  --col-gruene: #93bb51;
  --col-afd: #7fbecc;
  --col-fdp: #f8eb4a;
  --col-linke: #8a3b89;
}

* {
  box-sizing: border-box;
  font-family: 'Open Sans', sans-serif;
}

body,
h1,
h2,
h3,
p {
  margin: 0;
  line-height: 1em;
}

p {
  line-height: 1.5em;
  margin: 1em 0;
}

span {
  line-height: 1.5em;
}

h1 {
  margin: 2em 0 2em 0;
  font-weight: 800;
  font-style: italic;
  font-size: 1.625rem;
}

h2 {
  font-style: italic;
  font-weight: 800;
  display: inline;
  background-color: var(--red-primary);
  box-shadow: 10px 0 0 var(--red-primary), -10px 0 0 var(--red-primary);
  color: var(--white-primary);
  line-height: 1.625em;
  padding: 0.2em 0;
  font-size: 1.625rem;
  position: relative;
  top: -2em;
  margin-top: 3em;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
}

h2 + p {
  margin-top: -1em;
}

h3 {
  margin-bottom: 1em;
}


nav {
  position: fixed;
  background: var(--white-primary);
  width: 100%;
  z-index: 1000;
}

header {
  padding: 2em;
  background: var(--blue-primary);
}

header.dashboard {
  padding: 1em;
}

section {
  padding: 2em 0;
}

footer {
  padding: 2em 1em;
  text-align: center;
}

a {
  color: var(--red-primary);
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}

svg text {
  font-size: 0.75rem;
  cursor: default;
}

b {
  font-weight: 700;
}

/* external links */
a[href^="http"]:not([href*="wer-gewinnt-die-wahl"]):not(.plain)::after {
  content: '\f064';
  font-family: 'Font Awesome 5 Free';
  padding-left: 0.3em;
  font-size: 0.8em;
}

a:hover {
  color: var(--red-dark);
}

ul {
  margin: 1em 0;
}

ul li {
  line-height: 1.5em;
  margin-bottom: 0.2em;
}

.content {
  padding-top: 3.5rem;
}

p.answer {
  font-size: 1.125rem;
}

.container,
.container-lg {
  margin: 0 auto;
  width: min(90%, 1000px);
}

.table-container {
  overflow-x: auto;
  overflow-y: hidden;
}

.bg-blue {
  background: var(--blue-light);
}


.text-large {
    font-size: 1.25rem;
}

.mt-5 {
  margin-top: 4em;
}

.mt-2 {
  margin-top: 2em;
}

.text-center {
  text-align: center;
}


.text-left {
  text-align: left;
}

.emph {
  font-weight: 700;
}

.switch {
  border: 0;
  color: var(--black-primary);
  background: var(--white-primary);
  font-weight: 700;
  padding: 0.2em 1em;
  cursor: pointer;
  outline: 0;
}

.switch.active {
  color: var(--white-primary);
  background: var(--black-primary);
  font-style: italic;
}

line.grid {
  stroke: var(--black-primary);
}

line.grid.thin {
  stroke-width: 0.25;
}

.hover-overlay {
    fill: var(--blue-light);
    opacity: 0.7;
}

.note {
  font-weight: 700;
  font-size: 0.875rem;
}

.note.active {
  font-style: italic;
}

.label {
  font-weight: 400;
  font-size: 0.750rem;
}

.label.milestone {
  fill: var(--blue-dark)
}

.label-bg {
  font-weight: 400;
  font-size: 0.750rem;
  color: var(--blue-light);
  stroke-width: 0.3em;
  stroke: var(--blue-light);
}


.fill-blue-light {
  fill: var(--blue-light);
}


.estimate {
  stroke: var(--blue-dark);
  stroke-width: 3;
  fill: none;
}

.estimate-bg {
  stroke: var(--white-primary);
  stroke-width: 8;
  fill: none;
}

.estimate-uncertainty {
  opacity: 0.07;
  stroke: none;
}

.estimate-group.highlight .estimate-uncertainty {
  opacity: 0.2;
}

.estimate-uncertainty-upper,
.estimate-uncertainty-lower {
  fill: none;
  stroke-dasharray: 2,2;
  opacity: 0.5;
}


/* party utility classes */

.stroke-party-1 {
    stroke: var(--col-cdu);
}

.stroke-party-2 {
    stroke: var(--col-spd);
}

.stroke-party-3 {
    stroke: var(--col-afd);
}

.stroke-party-4 {
    stroke: var(--col-gruene);
}

.stroke-party-5 {
    stroke: var(--col-linke);
}

.stroke-party-6 {
    stroke: var(--col-fdp);
}


.fill-party-1 {
    fill: var(--col-cdu);
}

.fill-party-2 {
    fill: var(--col-spd);
}

.fill-party-3 {
    fill: var(--col-afd);
}

.fill-party-4 {
    fill: var(--col-gruene);
}

.fill-party-5 {
    fill: var(--col-linke);
}

.fill-party-6 {
    fill: var(--col-fdp);
}

.survey-point {
  opacity: 0.25;
}

.vue-js-switch {
  transform: scale(0.75);
  margin-bottom: 2px;
}

.vue-js-switch .v-switch-core {
  background-color: var(--gray-primary) !important;
}

.vue-js-switch.toggled .v-switch-core {
  background-color: var(--black-primary) !important;
}

.switch-survey-label {
  margin-right: 0.2em;
  font-weight: 700;
  font-size: 0.875rem;
  color: var(--gray-primary);
}

.switch-survey-label.active {
  color: var(--black-primary);
}

.party-name {
    vertical-align: middle;
    position: relative;
    font-weight: 700;
    margin-left: 1.8em;
}
.party-name::before {
    content: '';
    display: inline-block;
    width: 1.2em;
    height: 1.2em;
    border-radius: 0.6em;
    vertical-align: middle;
    position: absolute;
    left: -1.8em;
}

.party-1::before {
    background: var(--col-cdu);
}

.party-2::before {
    background: var(--col-spd);
}

.party-3::before {
    background: var(--col-afd);
}

.party-4::before {
    background: var(--col-gruene);
}

.party-5::before {
    background: var(--col-linke);
}

.party-6::before {
    background: var(--col-fdp);
}

.legend {
  margin: 1em;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}

.legend-item {
  margin: 0.3em 1em;
  font-size: 0.75rem;
  font-weight: 700;
}

.legend-item * {
  vertical-align: middle;
  margin: 0 0.5em;
}

line.milestone {
  stroke: var(--blue-dark);
  stroke-dasharray: 5, 5;
}

.sparkline {
  stroke: var(--black-primary);
  stroke-width: 1;
}

.spot {
  fill: var(--blue-dark);
}

@media screen and (min-width: 800px) {

  .container-lg {
    max-width: min(90%, 1100px);
    margin: 0;
    margin-left: max(5%, (100% - 900px) / 2);
  }

  .dashboard
  .container-lg {
    margin: 0 auto;
    max-width: min(90%, 1600px);
    width: min(90%, 1600px);
  }

  .split {
    display: flex;
  }

  .split > div {
    flex-basis: 100%;
  }

  .split > div + div {
    margin-left: 4em;
  }

  .content {
    padding-top: 6.5em;
  }

  p.answer {
    min-height: 3em;
  }
}

</style>
